import { z } from 'zod';
import { CampaignIO } from './io-types';

export const CreateProposalIOApiResponse = z
  .object({
    success: z.boolean(),
    message: z.string()
  })
  .meta({
    id: 'CreateProposalIOApiResponse',
    description: 'Response for proposal Zoho IO creation operations'
  });
export type CreateProposalIOApiResponse = z.infer<typeof CreateProposalIOApiResponse>;

export const CampaignIOsApiResponse = z.array(CampaignIO);
export type CampaignIOsApiResponse = z.infer<typeof CampaignIOsApiResponse>;

export const CampaignIOsApiRequest = z.object({
  zoho_campaign_id: z.string()
});
export type CampaignIOsApiRequest = z.infer<typeof CampaignIOsApiRequest>;
